// src/services/roleApi.js
// CRUD de roles (role.php) – listas desplegables y gestión

import { dotoniwoofApi } from '../api/dotoniwooApi';

/**
 * Lista todos los roles.
 * GET role.php
 * @returns {Promise<{ ok: boolean, status?: number, data?: { data: Array<{ id_role, role_name }> } }>}
 */
export const getRoles = async () => {
  try {
    const response = await dotoniwoofApi.get('/role.php');
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al listar roles:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Un rol por ID.
 * GET role.php/{id}
 */
export const getRoleById = async (id) => {
  try {
    const response = await dotoniwoofApi.get(`/role.php/${id}`);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al obtener rol:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Crear rol.
 * POST role.php  Body: { role_name: "string" }
 */
export const createRole = async (body) => {
  try {
    const response = await dotoniwoofApi.post('/role.php', body);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al crear rol:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Actualizar rol.
 * PUT role.php/{id}  Body: { role_name: "string" }
 */
export const updateRole = async (id, body) => {
  try {
    const response = await dotoniwoofApi.put(`/role.php/${id}`, body);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al actualizar rol:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};

/**
 * Borrar rol.
 * DELETE role.php/{id}
 * 409 si el rol está en uso (usuarios, empleados o acciones).
 */
export const deleteRole = async (id) => {
  try {
    const response = await dotoniwoofApi.delete(`/role.php/${id}`);
    return {
      ok: true,
      status: response.status,
      data: response.data
    };
  } catch (error) {
    console.error('Error al eliminar rol:', error);
    return {
      ok: false,
      status: error.response?.status || 500,
      data: error.response?.data || { message: 'Error de conexión' }
    };
  }
};
